// extracted by mini-css-extract-plugin
module.exports = {"root":"RemainingBalanceDue_root__1I1OK"};